
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.6 17.817a1 1 0 01-1.93-.518l.292-1.092c.133-.5-.138-1.014-.606-1.232a10.98 10.98 0 01-1.67-.966c-.423-.297-1.005-.275-1.371.09l-.8.8A1 1 0 012.1 13.486l.8-.8c.366-.365.388-.947.09-1.371a10.958 10.958 0 01-1.592-3.371c-.147-.532.217-1.054.76-1.153.544-.1 1.06.265 1.219.794a9.004 9.004 0 0017.246 0c.159-.53.674-.893 1.218-.794.543.098.908.62.76 1.152a10.958 10.958 0 01-1.591 3.372c-.298.424-.276 1.006.09 1.372l.8.8a1 1 0 01-1.415 1.414l-.8-.8c-.366-.366-.948-.388-1.371-.091a10.99 10.99 0 01-1.67.966c-.469.218-.74.732-.606 1.231l.292 1.094a1 1 0 01-1.931.517l-.293-1.094c-.134-.499-.626-.809-1.14-.764a11.07 11.07 0 01-1.932 0c-.515-.045-1.007.265-1.14.764L9.6 17.817z","fill":"#707381"}})])
          )
        }
      }
    